import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const CardSkeleton = () => {
  return (
    <div className="d-flex flex-wrap">
      {Array.from({ length: 6 }).map((_, index) => (
        <div key={index} className="col-xxl-2 col-lg-3 col-sm-4 col-6 my-20">
          <div className="product-card w-100 border border-gray-100 rounded-16">
            <Skeleton
              style={{
                width: "100%",
                borderTopLeftRadius: "16px",
                borderTopRightRadius: "16px",
              }}
            />
            <div className="product-card__content p-10 d-flex flex-column">
              <Skeleton
                width="100%"
                height="10rem"
                style={{ marginBottom: "1rem" }}
              />
              <Skeleton
                width="80%"
                height="1.5rem"
                style={{ marginBottom: "1rem" }}
              />
              <Skeleton
                width="50%"
                height="1.2rem"
                style={{ marginBottom: "0.5rem" }}
              />
              <Skeleton
                width="70%"
                height="1rem"
                style={{ marginBottom: "0.5rem" }}
              />
              <div className="flex-between align-items-center">
                <Skeleton width="30%" height="1rem" />
                <Skeleton
                  width="20%"
                  height="2rem"
                  style={{ borderRadius: "20px" }}
                />
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default CardSkeleton;
